import React from 'react';
import { newsArticles } from '../data/newsData';
import Header from '../../../shared/components/common/Header';
import Footer from '../../../shared/components/common/Footer';
import { useTheme } from '../../../shared/contexts/ThemeContext';
import ArticleCard from '../blog/ArticleCard';
import ContactDrawer from '../../../shared/components/common/ContactDrawer';

export default function BlogPage() {
  const { theme } = useTheme();

  return (
    <div className="relative bg-[#f3f6f8] min-h-screen flex flex-col">
      {/* Gradiente de fundo fixo no final da página */}
      <div
        className="absolute inset-x-0 bottom-0 h-[1600px] -z-10 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(to top, ${theme.gradientColor}, rgba(255, 255, 255, 0.3), transparent)`,
        }}
      ></div>

      <Header />

      {/* Hero Section */}
      <section className="pt-40 px-6 text-center bg-gray-100">
        <div className="max-w-4xl mx-auto">
          <p className="text-5xl font-extrabold text-gray-900 mb-4">
            Nosso Blog: Informação e Saúde
          </p>
          <p className="text-xl text-gray-600">
            Encontre artigos e notícias sobre distúrbios do sono, tratamentos e bem-estar para você e sua família.
          </p>
        </div>
      </section>

      {/* Grid de Artigos */}
      <main className="container mx-auto px-6 py-12 max-w-7xl flex-1">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Últimos Artigos</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </main>

      <Footer className="mt-60" />
      <ContactDrawer
        message="Vim do site"
      />
    </div>
  );
}
